import { Injectable, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

/**
 * Simple service providing the current route as Signal
 */
@Injectable({
  providedIn: 'root'
})
export class CurrentRouteService {
  private router = inject(Router);


  public currentRoute = signal<string>('');

  constructor() {

    // monitor the router
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute.set(event.urlAfterRedirects);
      }
    });
  }
}